import { render, staticRenderFns } from "./staffList.vue?vue&type=template&id=59cf6344&"
import script from "./staffList.vue?vue&type=script&lang=js&"
export * from "./staffList.vue?vue&type=script&lang=js&"
import style0 from "./staffList.vue?vue&type=style&index=0&id=59cf6344&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports